
$(function (){
  document.addEventListener("DOMContentLoaded", function(event) { 
    focus_element();
  });
});

function focus_element()
{
  var errors = $(".has-error input:first");
  if(errors.length > 0){
    errors.first().focus();
  }
  else{
    var focusers = $("form input.default_focus");
    if(focusers.length > 0){
      focusers.first().focus();
    }
    else{
      // var final_default = $("form input:visible");
      // if(final_default.length > 0){
      //   final_default.first().focus();
      // }
    }
  }
}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/focus.js